import { type ReactNode } from 'react';

/**
 * Minimal shell for the secondary unauthenticated screens (reset-password,
 * onboarding runner, public access-invite). The primary auth screens —
 * Welcome, Login, Signup, ForgotPassword — are full-bleed and self-contained,
 * so they render without this shell.
 */
export function AuthShell({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className="min-h-full bg-paper">
      <div className="mx-auto w-full max-w-md px-6 pt-safe-or-6 pb-safe-or-6">{children}</div>
    </div>
  );
}
